<template>
  <BsModal ref="exteriorCheckModalRef" class="fade">
    <!-- header -->
    <template v-slot:header></template>
    <!-- ./header -->

    <!-- body -->
    <div class="container-fluid">
      <div class="w-100 border mb-2">
        <div class="border p-1">
          <label for="A" class="text-nowrap me-2">
            <input type="radio" id="A" name="exterior-radio" value="A" />
            【A】キズ
          </label>
          <label for="B" class="text-nowrap me-2">
            <input type="radio" id="B" name="exterior-radio" value="B" />
            【B】傷を伴うヘコミ
          </label>
          <label for="C" class="text-nowrap me-2">
            <input type="radio" id="C" name="exterior-radio" value="C" />
            【C】腐食
          </label>
          <label for="G" class="text-nowrap me-2">
            <input type="radio" id="G" name="exterior-radio" value="G" />
            【G】ガラス点傷
          </label>
          <label for="P" class="text-nowrap me-2">
            <input type="radio" id="P" name="exterior-radio" value="P" />
            【P】要塗装
          </label>
          <label for="U" class="text-nowrap me-2">
            <input type="radio" id="U" name="exterior-radio" value="U" />
            【U】ヘコミ
          </label>
          <label for="N" class="text-nowrap me-2">
            <input type="radio" id="N" name="exterior-radio" value="" checked />
            【N】無し
          </label>
        </div>
      </div>
      <div
        class="w-100"
        style="
          background-image: url(/images/check_01.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        "
      >
        <div class="row d-flex flex-nowrap px-3" v-for="m in exteriorCheckRow" :key="m">
          <div
            v-for="n in exteriorCheckCol"
            :key="n"
            :id="'exterior_modal_' + m + '_' + n"
            class="col d-flex align-items-center justify-content-center exterior_cell border"
            style="height: 40px; font-size: 150%"
            :data-row="m"
            :data-col="n"
            @mousedown.prevent="setExteriorCheck(m, n)"
            @touchstart.prevent="setExteriorCheck(m, n)"
          ></div>
        </div>
      </div>
    </div>
    <!-- ./body -->
    <!-- footer -->
    <template v-slot:footer>
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
        閉じる
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @mousedown.prevent="setExteriorData()"
        @touchstart.prevent="setExteriorData()"
      >
        保存
      </button>
    </template>
    <!-- ./footer -->
  </BsModal>
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
import { BsModal } from "bs-modal-vue";
/* Import Components */
/* Import Variables */
/* Import Script */
import {
  exteriorCheckModalRef,
  setExteriorCheck,
  setExteriorData,
  exteriorCheckRow,
  exteriorCheckCol,
} from "../../../compositions/rentContract/carScratches/exterior";
export default defineComponent({
  components: {
    BsModal,
  },
  setup() {
    return {
      exteriorCheckModalRef,
      setExteriorCheck,
      setExteriorData,
      exteriorCheckRow,
      exteriorCheckCol,
    };
  },
});
</script>
